<script lang="ts">
    import { createEventDispatcher } from "svelte";
    import type { Proposition } from "../../models/proposition";
    import OutlineButton from "./outline-button.component.svelte";
        

    // Export
    export let propositions: Proposition[];

    // Var
    let dispatch = createEventDispatcher();
    // let selected: string = "";


    // // Reactivity
    // $: list =
    //     selected.trim().length <= 0
    //         ? []
    //         : propositions.filter((c) => c.title === selected)[0].proposals;

    // Functions
    const handleSelect = (p:string) => {
        dispatch('proposal-selected', p);
    }
</script>

<div>
    {#each propositions as p}
        <div class="proposition">
            <span class="proposition-title" > { p.title } </span> :
            {#each p.proposals as item }
                <span class="proposition-item" >
                    <OutlineButton on:click={() => handleSelect(item) } >{ item } </OutlineButton>
                </span>
            {/each}
        </div>
    {/each}
</div>

<style>

    .proposition {
        padding-top: 7px;
    }

    .proposition-item {
        padding-left: 5px;
    }

</style>